// Angular modules
import { NgModule }          from '@angular/core';
import { Routes }            from '@angular/router';
import { RouterModule }      from '@angular/router';

// Components
import { NotFoundComponent } from './static/not-found/not-found.component';
import { authGuard } from '@services/auth.guard';

const routes : Routes = [
  {
    path         : 'auth',
    loadChildren : () => import('./pages/auth/auth.module').then(m => m.AuthModule),
  },
  {
    path         : 'home',
    loadChildren : () => import('./pages/home/home.module').then(m => m.HomeModule),
  },
  {
    path         : 'account',
    loadChildren : () => import('./pages/account/account.module').then(m => m.AccountModule),
  },
  {
    path         : 'property',
    loadChildren : () => import('./pages/property-info/property-info.module').then(m => m.PropertyInfoModule),
    canActivate: [authGuard]
  },
  {
    path         : 'management',
    loadChildren : () => import('./pages/management/management.module').then(m => m.ManagementModule),
    canActivate: [authGuard]
  },
  {
    path         : 'wallet',
    loadChildren : () => import('./pages/wallet/wallet.module').then(m => m.WalletModule),
    canActivate: [authGuard]
  },
  {
    path : '',
    redirectTo : '/home',
    pathMatch : 'full'
  },
  {
    path : '**',
    component : NotFoundComponent
  }
];

@NgModule({
  imports : [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload',  anchorScrolling: 'enabled' })],
  exports : [RouterModule]
})
export class AppRoutingModule { }
